import React, { Component } from 'react'
import PropTypes from 'prop-types'
import Combokeys from 'combokeys'
import { isTouchDevice } from '../../../../utils/common'
import AssignmentResult from '../../assignmentResult'
import './style'

class Label extends Component {
	constructor(props) {
		super(props)
		this.state = {
			active: null,
		}
		this.combokeys = new Combokeys(document.documentElement)
	}

	componentWillMount() {
		this.attachComboKeys(this.props)
	}

	componentWillReceiveProps(nextProps) {
		if (
			nextProps.task.id === this.props.task.id &&
			nextProps.isNeedToShowTaskResults
		) {
			this.combokeys.reset()
		}

		if (
			nextProps.task.id !== this.props.task.id &&
			!nextProps.isNeedToShowTaskResults
		) {
			this.attachComboKeys(nextProps)
		}
	}

	componentWillUnmount() {
		this.combokeys.detach()
	}

	attachComboKeys(props) {
		const { task } = props
		const { values } = task.payload

		values.forEach((value, i) => {
			const idx = i + 1
			const key = idx === values.length ? '0' : idx.toString()

			this.combokeys.bind(key, () => {
				if (this.state.active !== null) return

				this.setState({ active: i })

				setTimeout(() => {
					this.setState({ active: null })
					this.props.markTask(values[idx - 1].value, null, task.type)
				}, 100)
			})
		})
	}

	render() {
		const {
			task,
			markTask,
			testLabel,
			caption,
			currentTaskCaption,
			description,
			fullDescriptionPopup,
			isNeedToShowTaskResults,
			comparedResult,
			rightScoreThreshold,
			nextTask,
		} = this.props
		const labels = task.payload.values
		const buttons = labels.map((item, i) => {
			const idx = (i === labels.length - 1) ? '0' : i + 1
			const text = isTouchDevice() ? item.text : `${idx}. ${item.text}`
			const className = []

			className.push(item.value === 'other' ? 'btn-border' : 'btn btn-gray')
			className.push(i === this.state.active ? 'active' : '')

			if (isNeedToShowTaskResults) {
				if (comparedResult.result === comparedResult.user && item.value === comparedResult.user) {
					className.push('formitem-success')
				} else {
					className.push(
						item.value === comparedResult.user ? 'formitem-fail' : '',
						item.value === comparedResult.result ? 'formitem-success' : '',
					)
				}
			}

			return (
				<span
					role="button"
					tabIndex="0"
					key={item.value}
					className={className.join(' ')}
					disabled={isNeedToShowTaskResults}
					onClick={() => { markTask(item.value, null, task.type) }}
					data-testid="taskCompleteButton"
				>
					{text}
				</span>
			)
		})

		const rightResult = isNeedToShowTaskResults
			? (
				<div className="buttons taskresult">
					<AssignmentResult isRight={comparedResult.score >= rightScoreThreshold[task.type]} />

					<span
						className="taskresult-next btn"
						role="button"
						tabIndex="0"
						onClick={nextTask}
					>
						Next
					</span>
				</div>
			)
			: ''

		return (
			<div className="annotation row">
				<div className="image col-4 col-sm-4 col-xs-2">
					<img className="image-value" src={this.props.task.payload.image} alt="" />
				</div>

				<div className="actions col-2 col-sm-4 col-xs-2">
					<div className="actions-inner">
						{testLabel}
						<div className="gap-back sm-hidden" />
						{currentTaskCaption}
						{caption}
						{description}
						<div className="gap-back sm-hidden" />
						<div className="buttons">
							{buttons}
						</div>
						{rightResult}
					</div>
				</div>
				{fullDescriptionPopup}
			</div>
		)
	}
}
Label.defaultProps = {
	testLabel: null,
	caption: null,
	description: null,
	comparedResult: {},
}
Label.propTypes = {
	task: PropTypes.object.isRequired,
	markTask: PropTypes.func.isRequired,
	testLabel: PropTypes.node,
	caption: PropTypes.node,
	currentTaskCaption: PropTypes.node.isRequired,
	description: PropTypes.node,
	fullDescriptionPopup: PropTypes.node.isRequired,
	isNeedToShowTaskResults: PropTypes.bool.isRequired,
	comparedResult: PropTypes.object,
	nextTask: PropTypes.func.isRequired,
	rightScoreThreshold: PropTypes.object.isRequired,
}

export default Label
